import { escapeHtml } from "../utils/escapeHtml";
import { formatNumber } from "../utils/formatting";

interface ComparisonData {
  label: string;
  current: number;
  previous: number;
  delta: number;
  pct: number;
  direction: "up" | "down" | "flat";
}

export function renderComparisonCards(container: HTMLElement, cards: ComparisonData[]): void {
  container.innerHTML = cards.map((c) => {
    const arrow = c.direction === "up" ? "\u2191" : c.direction === "down" ? "\u2193" : "\u2192";
    const colorClass = c.direction === "up" ? "comparison-up" : c.direction === "down" ? "comparison-down" : "comparison-flat";
    return `<div class="comparison-card ${colorClass}">
      <div class="comparison-label">${escapeHtml(c.label)}</div>
      <div class="comparison-values">
        <span class="comparison-current">${formatNumber(c.current)}</span>
        <span class="comparison-arrow">${arrow} ${c.pct >= 0 ? "+" : ""}${c.pct}%</span>
      </div>
      <div class="comparison-previous">vs ${formatNumber(c.previous)} prev</div>
    </div>`;
  }).join("");
}
